









































































































































































































































import { Component, Vue, Provide } from 'vue-property-decorator';
import {
  Action, Mutation, State, Getter, namespace,
} from 'vuex-class'; import NProgress from 'nprogress';
import {
  Message, Loading, Button, Select, Input, Pagination, Table, TableColumn, Option, OptionGroup, Rate,
} from 'element-ui';
import MyNav from '@/components/nav/Index.vue'; // nav
import Word from '@/servers/modules/vocabulary/wordlist'; // server
import Vocabulary from '@/servers/modules/vocabulary/vocabulary'; // server
import { Route } from 'vue-router'; // 检测规则

Vue.use(Loading.directive);
const wordlist = namespace('wordlist');
@Component({
  components: {
    Button,
    Select,
    Input,
    Table,
    TableColumn,
    MyNav,
    Option,
    OptionGroup,
    Rate,
    Loading,
    Message,
    Pagination,
  },
})
export default class extends Vue {
    // @ts-ignore 导航栏数据
    @Getter public navData: any;

    // @ts-ignore
    @Mutation public setSkeletonDescribe: any;

    // @ts-ignore
    @Getter public vteTitleData: any;

    // @ts-ignore
    @Getter public skeleton: any;

    // @ts-ignore
    @Getter public scaleCommonIndex: any;

    // 当前选项是否为释义
    private isParaphrase: boolean = true;

    // 当前是隐藏还是显示
    private paraphraseShow: boolean = false;

    // 图片地址
    private addImg: any = require('@/assets/images/add.png');

    private minusImg: any = require('@/assets/images/minus.png');

    private loading: boolean = true;

    // 输入框
    private inputValue: any = '';

    private selectType: any = '';

    // 词汇分类
    private value: any = '';

    private wordColStatus: boolean = true;

    private wordColDetailStatus: boolean = false;

    // 单元select 请求状态
    private unitValue: any = '全部单元';

    // 总条数
    private totalNumber: any = 0;

    // 总页数
    private pages: any = null;

    private unitData: any = {};

    private title: any = '';

    // 难度值
    private diffValue: any = '全部难度';

    // 词关系
    private infoData: any = [
      { id: '0', value: '释义' },
      { id: '1', value: '例句' },
      { id: '2', value: '词关系' },
      { id: '3', value: '词汇辨析' },
      { id: '4', value: '常用搭配' },
      { id: '5', value: '助记语' }];

    private infoValue: any = '0';

    // 顺序
    private orderData: any = [
      {
        title: '学习顺序',
        value: 0,
      },
      {
        title: '词汇字母顺序',
        value: 1,
      },
      {
        title: '难度倒序',
        value: 2,
      },
    ]

    // star 变量
    private star1: number = 1;

    private star2: number = 2;

    private star3: number = 3;

    private star4: number = 4;

    private star5: number = 5;

    private currentIndex: any = 0;

    // 全部词汇
    private allWordNum: any = null;

    // 已学词汇
    private studyWordNum: any = null;

    // 未学词汇
    private notStudyWordNum: any = null;

    // 生词本
    private troubleWordNum: any = null;

    private tableData:any = [];

    private data: any = {
      courseId: '',
      currentPage: '',
      diff: '',
      orderWay: '',
      pageSize: '',
      selectType: '3',
      unit: '',
      word: '',
      userId: '',
      userCourseId: '',
      falg: '0',
    }

    private handleCurrentChange(val:any) {
      this.data.currentPage = val;
      this.getArrData(val);
    }

    // 表格高度
    private tableHeight: any = document.body.clientHeight - 250 - 56

    private tableRowClassName() {
      return 'table-header';
    }

    beforeRouteEnter(to: Route, from: Route, next: () => void): void {      
      if (from.name == 'worddetail') {
        window.location.reload();
        return;
      }
      next();
    }

    private created() {
      this.setSkeletonDescribe(true);
      this.title = window.LS.get('vteData').course.shortTitle;
      // 词汇分类 vteTitleData
      this.allWordNum = window.LS.get('vteTitleData').allWordNum;
      this.studyWordNum = window.LS.get('vteTitleData').studyWordNum;
      this.notStudyWordNum = window.LS.get('vteTitleData').notStudyWordNum;
      this.troubleWordNum = window.LS.get('vteTitleData').troubleWordNum;

      this.data.courseId = window.LS.get('vteData').course.courseId;
      this.data.userId = window.LS.get('vteData').user.userId;
      this.data.userCourseId = window.LS.get('vteData').userCourseId;
      this.data.currentPage = 1;
      this.data.diff = '';
      if (this.unitValue == '全部单元') {
        this.data.unit = '';
      } else {
        this.data.unit = this.unitValue;
      }
      if (this.diffValue == '全部难度') {
        this.data.diff = '';
      } else {
        this.data.diff = this.diffValue;
      }
      this.data.orderWay = 0;
      this.data.pageSize = 10;
      this.data.selectType = 3;
      // 从首页查看生词进来的，默认选择生词本选项
      if (this.$route.query.isIndexPage) {
        this.data.selectType = 2;
      }
      Promise.all([
        this.getStudyList(this.data), // 获取tabel数据
        this.getWordALLUnit({
          courseId: window.LS.get('vteData').course.courseId,
        }),
        this.getWordNum({
          courseId: window.LS.get('vteData').course.courseId,
          userId: window.LS.get('vteData').user.userId,
          userCourseId: window.LS.get('vteData').userCourseId,
        }),
      ]).then((res: any) => {
        this.loading = false;
        this.tableData = res[0].data.data.list || [];
        // 条数

        this.totalNumber = res[0].data.data.total;
        this.pages = res[0].data.data.pages;
        this.tableData = this.tableData.map((item: any) => ({
          wordStatus: true,
          wordDetailStatus: false,
          ...item,
          togglePlayModel: false,
        }));

        // 单元
        this.unitData = res[1].data.data;
        this.allWordNum = res[2].data.data.allWordNum;
        this.studyWordNum = res[2].data.data.studyWordNum;
        this.notStudyWordNum = res[2].data.data.notStudyWordNum;
        this.troubleWordNum = res[2].data.data.troubleWordNum;
        this.unitData.unshift('全部单元');
        NProgress.done();
        this.setSkeletonDescribe(false);
      });
    }

    // 获取查询课程词汇数量
    private async getWordNum(data: any) {
      return await Vocabulary.getWordNum(data);
    }

    // 查看词汇
    private async getStudyList(data: any) {

      return await Word.selectUserWordListPage(data);
    }

    // 查询课程所有单元
    private async getWordALLUnit(data: any) {
      return await Word.getWordALLUnit(data);
    }

    private seeWord() {
      this.wordColStatus = !this.wordColStatus;
      if (this.wordColStatus) {
        this.tableData.map((item: any) => {
          item.wordStatus = true;
        });
      } else {
        this.tableData.map((item: any) => {
          item.wordStatus = false;
        });
      }
    }

    private seeWordDetail() {
      this.wordColDetailStatus = !this.wordColDetailStatus;
      if (this.wordColDetailStatus) {
        this.tableData.map((item: any) => {
          item.wordDetailStatus = true;
        });
      } else {
        this.tableData.map((item: any) => {
          item.wordDetailStatus = false;
        });
      }
    }

    // 选择筛选条件之后调取数据
    private async changeGetStudyList(data: any) {
      this.loading = true;
      this.data.currentPage = 1;
      this.tableData = [];
      const res = await Word.selectUserWordListPage(data);
      this.loading = false;
      this.tableData = res.data.data.list || [];

      this.totalNumber = res.data.data.total;

      // infoValue==0是释义，需要隐藏掉释义内容，wordDetailStatus为false
      if (this.infoValue == 0) {
        this.tableData = this.tableData.map((item: any) => ({
          wordStatus: true,
          wordDetailStatus: false,
          ...item,
        }));
      } else {
        this.tableData = this.tableData.map((item: any) => ({
          wordStatus: true,
          wordDetailStatus: true,
          ...item,
        }));
      }
    }

    // 选择词汇分类
    private changeSelectType() {
      this.changeGetStudyList(this.data);
    }

    // 选择单元 处理展示全部
    private changeUnit() {
      if (this.unitValue == '全部单元') {
        this.data.unit = '';
      } else {
        this.data.unit = this.unitValue;
      }
      this.changeGetStudyList(this.data);
    }

    // 选择难度
    private changeDiff() {
      if (this.diffValue == '全部难度') {
        this.data.diff = '';
      } else {
        this.data.diff = this.diffValue;
      }
      this.changeGetStudyList(this.data);
    }

    // 选择顺序
    private changeOrder() {
      this.changeGetStudyList(this.data);
    }

    // 搜索
    private clickSearch() {
      this.data.localtionWord = '';
      this.data.currentPage = 1;
      this.tableData = [];
      this.data.word = this.inputValue;
      this.changeGetStudyList(this.data);
    }

    private clickLocaltion() {
      this.data.word = '';
      this.data.currentPage = 1;
      this.tableData = [];
      this.data.localtionWord = this.inputValue;
      this.changeGetStudyList(this.data);
    }

    // 定位
    // 词汇信息 释意 例句 词关系
    private changeInfo(item: any) {

      // 如果为释义则有显示隐藏功能
      if (item == '0') {
        this.isParaphrase = true;
      } else {
        this.isParaphrase = false;
      }
      this.data.falg = item;
      this.changeGetStudyList(this.data);
    }

    private async getArrData(val:any) {
      this.loading = true;
      this.getStudyList(this.data).then((res: any) => {
        this.loading = false;
        if (res.data.data.list) {

          this.tableData = res.data.data.list || [];
          this.tableData = this.tableData.map((item: any) => {
            // 滚动加载数据的时候 如果当前选择的是释义 则有显示和隐藏的选项
            // 如果选择除了释义之外的其他选项 则全部为显示
            if (this.isParaphrase) { // 为释义
              return {
                wordStatus: true,
                wordDetailStatus: !!this.wordColDetailStatus,
                ...item,
              };
            }
            return {
              wordStatus: true,
              wordDetailStatus: true,
              ...item,
            };
          });
        } else if (val) {

          if (res.data.data.list) {

            this.tableData = res.data.data.list || [];
            this.tableData = this.tableData.map((item: any) => {
              // 滚动加载数据的时候 如果当前选择的是释义 则有显示和隐藏的选项
              // 如果选择除了释义之外的其他选项 则全部为显示
              if (this.isParaphrase) { // 为释义
                return {
                  wordStatus: true,
                  wordDetailStatus: !!this.wordColDetailStatus,
                  ...item,
                };
              }
              return {
                wordStatus: true,
                wordDetailStatus: true,
                ...item,
              };
            });
          }
        }
      });
    }

    // infinite 触底
    private async load(val:any) {
      if (this.tableData.length !== 0) {
        this.loading = true;
        this.data.currentPage++;
        this.getStudyList(this.data).then((res: any) => {
          this.loading = false;
          if (res.data.data.list) {

            this.tableData = this.tableData.concat(res.data.data.list);
            this.tableData = this.tableData.map((item: any) => {
              // 滚动加载数据的时候 如果当前选择的是释义 则有显示和隐藏的选项
              // 如果选择除了释义之外的其他选项 则全部为显示
              if (this.isParaphrase) { // 为释义
                return {
                  wordStatus: true,
                  wordDetailStatus: !!this.wordColDetailStatus,
                  ...item,
                };
              }
              return {
                wordStatus: true,
                wordDetailStatus: true,
                ...item,
              };
            });
            // - this.totalNumber = this.tableData.length;
            // - this.troubleWordNum = this.tableData.length;
          } else if (val) {

            if (res.data.data.list) {

              this.tableData = this.tableData.concat(res.data.data.list);
              this.tableData = this.tableData.map((item: any) => {
                // 滚动加载数据的时候 如果当前选择的是释义 则有显示和隐藏的选项
                // 如果选择除了释义之外的其他选项 则全部为显示
                if (this.isParaphrase) { // 为释义
                  return {
                    wordStatus: true,
                    wordDetailStatus: !!this.wordColDetailStatus,
                    ...item,
                  };
                }
                return {
                  wordStatus: true,
                  wordDetailStatus: true,
                  ...item,
                };
              });
            }

            // - this.totalNumber = this.tableData.length;
            // - this.troubleWordNum = this.tableData.length;
          }
        });
      }

    }

    private get wordUrl() {
      return this.wordColStatus ? require('@/assets/images/ui-word/word-eye-open.png') : require('@/assets/images/ui-word/word-eye-close.png');
    }

    private get wordDetailUrl() {
      return this.wordColDetailStatus ? require('@/assets/images/ui-word/word-eye-open.png') : require('@/assets/images/ui-word/word-eye-close.png');
    }

    private seeWordItem(col: any, index: any) {
      if (this.infoValue != '0') {
        return false;
      }
      col.row.wordStatus = !col.row.wordStatus;
    }

    private seeWordDetailItem(col: any, index: any) {
      if (this.infoValue != '0') {
        return false;
      }
      col.row.wordDetailStatus = !col.row.wordDetailStatus;
    }

    private playSound(scope: any) {
      scope.row.togglePlayModel = true;
      setTimeout(() => {
        scope.row.togglePlayModel = false;
      }, 1000);

      this.$refs.audio.src = scope.row.pronunciationus;
      this.$refs.audio.play();
    }

    // 加入生词本
    private async add(scope: any, event: any) {

      const data = {
        courseId: window.LS.get('vteData').course.courseId,
        operType: 0,
        userCourseWordId: scope.row.usercoursewordid,
        userId: window.LS.get('vteData').user.userId,
      };
      if (scope.row.addTroubleWordIs) {
        data.operType = 1;
      }

      const res = await Word.addOrRemoveTroubleWord(data);
      if (res.data.code == 0) {
        scope.row.addTroubleWordIs = !scope.row.addTroubleWordIs;
        if (!scope.row.addTroubleWordIs) {
          Message.success('已从生词本移出');
          // this.tableData
          console.log(data,this.tableData)
          this.troubleWordNum--;
          // selectType==2是生词范围，当生词和释义例句结合匹配时需要增加数量
          if (this.data.selectType == 2) {
            this.totalNumber--;
            this.tableData.splice(
              this.tableData.indexOf(
                this.tableData.find((item:any)=>{
                  return item.usercoursewordid == data.userCourseWordId
            })),1)
            if(this.totalNumber == 10){
              this.getArrData(1)
            }
          }
        } else {
          Message.success('已加入生词本');
          this.troubleWordNum++;
        }
      }
    }

    // 移出生词本
    private minus(scope: any) {

    }

    // 查看词汇详情
    private detail(scope: any) {
      this.$router.push(
        {
          path: '/vocabulary/worddetail',
          query: {
            courseWordId: scope.row.coursewordid,
            inputWay: 1,
          },
        },
      );
    }

    private troubleWordStudy() {
      // 记忆生词
      this.$router.push(
        {
          path: '/vocabulary/study',
          query: {
            studyType: 1,
            // inputWay: 2,
          },
        },
      );
    }
}
